import { useQuery } from '@tanstack/react-query';
import fetchData from '@/utils/fetchData';
import useError from '@/hooks/useError';
import useSmartlook from '@/hooks/useSmartlook';
import type { Client } from '@/hooks/providers/useClientProviders';

export function useClientQuery(enabled = true) {
  const { showError } = useError();
  const { error } = useSmartlook();
  return useQuery<Client>({
    queryKey: ['client'],
    queryFn: async () => {
      try {
        const resp = await fetchData('/client');

        return resp;
      } catch (e) {
        error('[useClientQuery][GET /client]', e);
        showError();
        throw e;
      }
    },
    enabled,
  });
}
